import { ManageAccounts } from "@mui/icons-material";
import { Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import LoaderComp from "../../../../components/Loader/LoaderComp";
import { useProfile } from "../../../../context/ProfileProvider/useProfile";
import { Organization } from "../../../../model/OrganizationModel";
import { UserGet } from "../../../../model/UserModel";
import { GetOneOrganization } from "../../../../services/OrganizationServices";
import { GetUser } from "../../../../services/UserServices";
import { MenuComponentProps } from "../RenderUserMenuOptions";
import { DataRenderPersonalInformation } from "./DataRenderPersonalInformation";
import { DataRenderPictureSection } from "./DataRenderPictureSection";
import { DataRenderPassword } from "./DatarRenderPassword";

export function MyDataRender({
    FooterComponent,
    HeaderComponent,
    setAlertColor,
    setMessage,
    setPopupOk
}: MenuComponentProps) {

    // region states
    const profile = useProfile();
    const { t } = useTranslation();
    const [username, setUsername] = useState<string>(profile.username!);
    const [phone, setPhone] = useState<string>(profile.userPhone!);
    const [organization, setOrganization] = useState<Organization>();
    const [userGetted, setUserGetted] = useState<UserGet>({} as UserGet);
    const [isAdminOrganizationOrRead, setIsAdminOrganizationOrRead] = useState<{ isAdmin: boolean, isReader: boolean }>({
        isAdmin: false,
        isReader: false
    });
    const [needReload, setNeedReload] = useState<boolean>(false);
    const { nameOrg } = useParams();
    //endregion

    //region useEffects
    useEffect(() => {
        if (nameOrg != undefined && nameOrg != "") {
            GetOneOrganization(nameOrg)
            .then(data => {
                setOrganization(data!)
            })
            .catch()
            .finally() 
        }

        GetUser(profile.id!)
        .then(data => {
            setUserGetted(data)
        })
        .catch()
    }, [])

    useEffect(() => {
        isUserOrgAdminOrReader();
    }, [userGetted])
    //endregion

    //region functions
    const isUserOrgAdminOrReader = () => {
        for(let i = 0; i < userGetted.organizations?.length!; i++) {
            if (userGetted.organizations![i].internalName == nameOrg!) {
                if (userGetted.organizations![i].isAdminOrganization) {
                    setIsAdminOrganizationOrRead({
                        isAdmin: true,
                        isReader: false
                    });
                    break
                }
            }
        }
    }
    //endregion

    return (
        <Grid item xs={10} paddingBottom="70px" >
            { needReload ? (
                <LoaderComp />
            ) : (
            <Grid container width="100%" height="100%">
                <HeaderComponent
                    contentString={t("MyData.PersonalizeExp")}
                    icon={<ManageAccounts fontSize="large" sx={{ color: "#22638D" }} />}
                    title={t("MyData.Mydata")}
                    username={username}
                    phone={phone}
                    organization={organization!}
                    isAdminOrganizationOrRead={isAdminOrganizationOrRead}
                    loginType={userGetted.loginType}
                    setNeedReload={setNeedReload}
                    setAlertColor={setAlertColor}
                    setMessage={setMessage}
                    setPopupOk={setPopupOk}
                />
                <DataRenderPictureSection 
                    setAlertColor={setAlertColor}
                    setMessage={setMessage}
                    setPopupOk={setPopupOk}
                />
                <DataRenderPersonalInformation 
                    phone={phone}
                    setPhone={setPhone}
                    setUsername={setUsername}
                    username={username}
                    setAlertColor={setAlertColor}
                    setMessage={setMessage}
                    setPopupOk={setPopupOk}
                />
                <DataRenderPassword 
                    setAlertColor={setAlertColor}
                    setMessage={setMessage}
                    setPopupOk={setPopupOk}
                />
                <FooterComponent />
            </Grid>
            ) }
        </Grid>
    )
}